import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import CardSkeleton from '@/app/common/components/skeleton/CardSkeleton';
import LineTimeChart from '@/app/common/components/LineTimeChart';
import { getColor } from '@/helpers/utils';
import { useLazyGetKeywordSearchVolumeQuery } from '@/app/KeywordTracker/api/keywordsApi';
import DrawerWrapper from '@/app/common/components/DrawerWrapper';


const KeywordSearchVolumeDrawer = () => {
  const [chartData, setChartData] = useState(null);
  const { key, payload } = useSelector(state => state.drawer);
  const { location_code, language_code, keywords } = payload ?? '';
  const [getSearch] = useLazyGetKeywordSearchVolumeQuery();
  useEffect(() => {
    if (key === 'search_volume_tracker') {
      getSearch({
        location_code,
        language_code,
        keywords
      })
        .unwrap()
        .then(res => {
          setChartData(res);
        });
    }

    return () => {
      setChartData(null);
    };
  }, [location_code, language_code, keywords]);

  return (
    <DrawerWrapper
      show={key === 'search_volume_tracker'}
      title={
        <div className="d-flex flex-wrap gap-3 align-items-center">
          <h6 className="m-0 fw-light">
            نمودار روند جستجو &nbsp;
            <span className="fw-bolder">
              ( {keywords ? decodeURIComponent(keywords[0]?.keyword) : ''} )
            </span>
          </h6>
        </div>
      }
    >
      {chartData ? (
        <LineTimeChart
          topLabel="روند جستجو"
          dates={chartData ? chartData?.data?.search_volume_dates : []}
          series={
            chartData
              ? [
                  {
                    name: 'روند جستجو',
                    data: chartData?.data?.search_volume_values,
                    color: getColor('navbar-vertical-default-link-active-color')
                  }
                ]
              : []
          }
        />
      ) : (
        <CardSkeleton />
      )}
    </DrawerWrapper>
  );
};

export default KeywordSearchVolumeDrawer;
